// Author liang gang qiang
// Date 2021-11-22 12:04:32

class MintalMesPrdShiftHandover {
constructor({
        id = null,
        shiftPlanId = '',
        shiftPlanCode = '',
        code = '',
        weather = '',
        currentSituation = '',
        currentProblem = '',
        handoverNotices = '',
        handoverManager = '',
        handoverDutyMan = '',
        dailyManager = '',
        dailyDutyMan = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.shiftPlanId = shiftPlanId;
    this.shiftPlanCode = shiftPlanCode;
    this.code = code;
    this.weather = weather;
    this.currentSituation = currentSituation;
    this.currentProblem = currentProblem;
    this.handoverNotices = handoverNotices;
    this.handoverManager = handoverManager;
    this.handoverDutyMan = handoverDutyMan;
    this.dailyManager = dailyManager;
    this.dailyDutyMan = dailyDutyMan;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdShiftHandover();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'weather',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.grid.weather',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'currentSituation',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.grid.currentSituation',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'currentProblem',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.grid.currentProblem',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'handoverNotices',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.grid.handoverNotices',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'handoverManager',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.grid.handoverManager',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'dailyManager',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.grid.dailyManager',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '未交接' },
                            { value: '2', text: '已交接' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    shiftPlanIdFilter : '',
    shiftPlanCodeFilter : '',
    codeFilter : '',
    weatherFilter : '',
    currentSituationFilter : '',
    currentProblemFilter : '',
    handoverNoticesFilter : '',
    handoverManagerFilter : '',
    handoverDutyManFilter : '',
    dailyManagerFilter : '',
    dailyDutyManFilter : '',
    statusFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'shiftPlanCodeFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.filter.shiftPlanCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdShiftPlan'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"shiftPlanId": "id"}'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'weatherFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.filter.weather',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'currentSituationFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.filter.currentSituation',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'currentProblemFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.filter.currentProblem',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'handoverNoticesFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.filter.handoverNotices',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'handoverManagerFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.filter.handoverManager',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'dailyManagerFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.filter.dailyManager',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.filter.status',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '未交接' },
                { value: '2', text: '已交接' }
            ]
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.entity.shiftPlanCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdShiftPlan'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"shiftPlanId": "id"}'
                }
        },
        {
        key: 'weather',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.entity.weather',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'currentSituation',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.entity.currentSituation',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'currentProblem',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.entity.currentProblem',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'handoverNotices',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.entity.handoverNotices',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'handoverManager',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.entity.handoverManager',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'dailyManager',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.entity.dailyManager',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdShiftHandover.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdShiftHandover, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
